// extracted by mini-css-extract-plugin
export default {"sider":"sider_sider__XTKxQ","logoContainer":"sider_logoContainer__ipm9v","logo":"sider_logo__gVbiD","menuContainer":"sider_menuContainer__XYtFg"};